import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { PublicProfileStore } from 'src/app/stores/public-profile.store';

@Component({
  selector: 'app-payment-methods',
  imports: [CommonModule, TranslateModule, MatTooltipModule, MatIconModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (publicProfileStore.hasAcceptedAssets()) {
      <div id="payment-methods-section" class="bg-bg-gray p-3 pb-2 rounded-xl relative">
        <h2 class="text-gray-500 text-xs font-semibold mb-2 sm:mb-3 uppercase absolute -top-2 left-4">
          {{ 'payWith' | translate }}
        </h2>
        <div class="flex gap-2">
          @for (asset of publicProfileStore.userAcceptedAssets(); track asset.assetTicker) {
            <div class="w-6 h-6 sm:w-8 sm:h-8 rounded-full flex items-center justify-center">
              <mat-icon
                [svgIcon]="asset.assetTicker"
                class="w-6 h-6 sm:w-8 sm:h-8"
                [matTooltip]="asset.assetTicker"
                toggleMatTooltip
              >
              </mat-icon>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="no-accepted-payments">
        {{ 'thisUserIsNotCurrentlyAcceptingPayments' | translate }}
      </div>
    }
  `,
})
export class PaymentMethodsComponent {
  protected publicProfileStore = inject(PublicProfileStore);
}
